var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecycle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.05051 0C7.81809 0 7.60545 0.123628 7.48676 0.321432L4.98454 4.53961L4.81641 4.82643L9.57855 7.57591L9.74668 7.28909L11.9324 3.64455C11.9324 3.64455 11.3341 2.67036 10.4341 1.21155C9.84559 0.2522 8.9258 0 8.05051 0Z",
    fill: "#11294C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9263 7.21492L20.6411 2.51212L18.9499 3.4863L17.6642 1.25606C17.2142 0.479676 16.3834 0 15.4834 0H9.51465C10.4147 0 10.8597 0.479676 11.3097 1.25606L14.1828 6.23578L12.4916 7.20997H17.9263V7.21492Z",
    fill: "#11294C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45336 12.1544L8.1446 13.1286L5.42974 8.42578H0L1.69122 9.39997L0.405503 11.6253C-0.0445024 12.4017 -0.0445024 13.361 0.405503 14.1423L3.3874 19.31C2.9374 18.5336 3.13025 17.9056 3.58025 17.1292L6.45336 12.1544Z",
    fill: "#11294C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.57906 15.4677L5.33122 15.3984C5.33122 15.3984 4.78726 16.4023 3.97131 17.9106C3.43724 18.9045 3.67954 19.8243 4.11966 20.5809C4.2334 20.7837 4.44604 20.9073 4.67846 20.9073L9.57906 20.9666H9.91039V15.4677H9.57906Z",
    fill: "#11294C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M23.9146 13.0497L21.5113 8.77217L21.3481 8.48535L16.5859 11.2348L16.7541 11.5216L18.8162 15.2354C18.8162 15.2354 19.9585 15.2058 21.6744 15.1563C22.8019 15.1217 23.4794 14.4541 23.9146 13.6926C24.0283 13.4997 24.0283 13.2524 23.9146 13.0497Z",
    fill: "#11294C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1896 15.8937H15.4434V13.9453L12.7285 18.6481L15.4434 23.3509V21.3976H18.0148C18.9148 21.3976 19.7456 20.9179 20.1956 20.1415L23.1775 14.9739C22.7275 15.7503 22.0896 15.8937 21.1896 15.8937Z",
    fill: "#11294C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycle);
export default __webpack_public_path__ + "static/media/recycle.776454b7a36ba817764fe10e50f8f215.svg";
export { ForwardRef as ReactComponent };